<taku-settings-cards [pageTitle]="pageTitle" [pageIconStyleClass]="pageIconStyleClass" [cardsInfo]="cardsInfo">
</taku-settings-cards>
